import styled from 'styled-components';
import AccordionFromUiReact from '@ertelecom/ui-react/components/accordion';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const Container = styled.div`
  padding: 110px 7% 40px;
  width: 100%;
  @media only screen and (max-width:640px) {
    padding: 40px 20px 40px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 985px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  margin-bottom: 20px;
  ${FONTS.H1};
  @media only screen and (max-width:640px) {
    ${FONTS.H2};
  }
`;

export const Accordion = styled(AccordionFromUiReact)`
  & + & {
    border-top: none;
  }
`;

export const Document = styled.div`
  margin-left: 10px;

  & + & {
    margin-top: 15px;
  }
`;

export const DocumentWrapper = styled.div`
  display: block;
`;
